(ns hai.admin-ui.users.groups.table
  (:require
   [com.wsscode.pathom3.connect.operation :as pco]
   [hai-model.model :as model]
   [hai.sharing.components :as sharing.components]
   [hai.ui.components.collection.views.cards :as cards]
   [hai.sharing.helper :as sharing]
   [hai.users.form :as user.form]
   [hai.ui.components.card :as card]
   [hai.admin-ui.users.groups.components :as components]
   [hai.users.helper :as users]
   [hai.admin-ui.users.table :as users.table]
   [hai.ui.components :as c]
   [hai.ui.components.collection.bulk-actions :as bulk-actions]
   [hai.ui.components.collection.filters :as filters]
   [hai.ui.components.collection.form :as col.form]
   [hai.ui.components.collection.table :as collection]
   [hai.ui.components.collection.views.table :as table]
   [hai.ui.components.new-design.button :as button]
   [hai.ui.icons :as icons]
   [hai.ui.rf-sugar :refer [>e]]
   [hai.web-app.layout :as layout]
   [lambdaisland.ornament :as o]
   [malli.util :as mu]))

(def GroupEditSchema
  (mu/select-keys model/Organisation [:group/uuid :group/display-name :group/description]))

(o/defstyled link-render* :div
  [icons/outlined-edit
   {:fill c/--accent-a11}]
  ([entity]
   [c/link-button
    {:on-click (fn [_] (>e [:routing/navigate [:groups/edit entity]]))}
    [icons/outlined-edit]]))

(defn link-render
  [entity]
  [table/table-cell
   (when (sharing/can-edit? entity)
     [link-render* entity])])

(defn group-members-render
  [{:group/keys [members]
    :as entity}]
  (cond
    (sharing/can-edit? entity)
    [table/modal-cell
     {:text (table/label
             {:items members
              :xform (map users/->label)
              :text "Add +"})
      :on-close (fn [] (>e [:table/resolve ::table]))}
     [c/DialogTitle "Manage Organisation"]
     [c/DialogDescription "Users in this organisation"]
     [components/group-members-table entity]]

    (pos? (count members))
    [table/modal-cell
     {:text (table/label
             {:items members
              :xform (map users/->label)})
      :on-close (fn [] (>e [:table/resolve ::table]))}
     [c/DialogTitle "Manage Organisation"]
     [c/DialogDescription "Users in this organisation"]
     [components/group-members-table entity]]

    :else
    [table/table-cell [:em "Empty Group"]]))

(defn table
  []
  [collection/component
   {:id ::table
    :update-mutation 'group/update
    :schema GroupEditSchema
    :query [{:user.groups/table [{:collection/items [:group/uuid
                                                     :group/display-name
                                                     ;; TODO
                                                     ;; :group/type
                                                     (pco/? :group/description)
                                                     :user.entity/permissions
                                                     (pco/? {:group/members users/query})
                                                     sharing.components/shared-with-query]}]}]
    :paginate? true
    :no-items (fn [_] [:em "No organisations or teams found"])
    ;; TODO default card render
    :card (fn [collection item]
            [card/card
             [cards/card-select-checkbox collection item]
             [cards/column-render collection item]])
    :columns [{:header "Name"
               :attr   :group/display-name
               :field  (col.form/link-input :groups/edit)
               :filter (filters/text-search {:placeholder "Name..."})}
              {:header "Description"
               :attr   :group/description
               :field  col.form/input
               :filter (filters/text-search {:placeholder "Description..."})}
              {:header "Users"
               :attr   :group/members
               :sort?  false
               :render group-members-render
               :filter {:schema [:vector :string]
                        :type   :filter/multi-select
                        :field  user.form/user-search-emails-field}}
              sharing.components/shared-with-column]
    :bulk-actions [{:title     "Delete"
                    :mutation  'group/delete
                    :disabled? (fn [group] (not (sharing/can-edit? group)))
                    :alert     {:content (fn [{:table/keys [selected] :as table} action]
                                           [bulk-actions/confirm-dialog
                                            {:table  table
                                             :action action}
                                            [bulk-actions/title "Confirm Deletion of Organisations or Teams"]
                                            [bulk-actions/description "Are you sure you want to delete the following Organisations or Teams?"]
                                            (into [:ul]
                                                  (map (fn [{:group/keys [display-name]}]
                                                         [:li [:strong display-name]]))
                                                  selected)])}}]}])

(defn- section-header [title action]
  [:div {:style {:display       "flex" :align-items "center" :justify-content "space-between"
                 :margin-bottom "4px"}}
   [:span {:style {:text-transform "uppercase" :font-weight "700" :font-size "0.8125rem"
                   :letter-spacing "0.05em" :color "var(--gray-10)"}}
    title]
   action])

(defn page
  [_]
  [layout/page
   [layout/breadcrumbs]
   [layout/heading]
   [layout/lead "Who's in your workspace and what they can do. Group people by project or team to share the right things with the right people."]
   [layout/content
    [section-header "Members" nil]
    [users.table/table]
    [:div {:style {:margin-top "32px"}}
     [section-header "Teams & Groups"
      [button/dark-small
       {:on-click (fn [_] (>e [:routing/navigate [:user.groups/create]]))
        :text     "Create a team"
        :icon [icons/plus]}]]
     [table]]]])
